function loadStage() {
  if (loadStage.loaded) return;
  loadStage.loaded = true;
  const s = document.createElement('script');
  s.src = 'https://dashboard.stage.bio/static/bundle.js';
  s.async = true;                 // don’t block parsing
  s.crossOrigin = 'anonymous';    // better caching across pages
  document.head.appendChild(s);
}

// Load when the facade actually enters the viewport
const io = new IntersectionObserver(es => {
  if (es.some(e => e.isIntersecting)) { io.disconnect(); loadStage(); }
}, { rootMargin: '0px 0px 200px 0px' });

// Observe the stage widget only if it exists
const stageWidget = document.getElementById('stage-widget');
if (stageWidget) {
  io.observe(stageWidget);
}
